export const OP = Object.freeze({
  auth: Object.freeze({
    login: 'auth.login',
    signup: 'auth.signup',
    me: 'auth.me',
    migrationList: 'auth.migration.list',
    migrationCopy: 'auth.migration.copy',
    migrationComplete: 'auth.migration.complete',
    adminUsageUsers: 'auth.admin.usageUsers',
    adminAccounts: 'auth.admin.accounts',
    adminApprove: 'auth.admin.approve',
    adminReject: 'auth.admin.reject',
    usageSummary: 'auth.usage.summary',
  }),

  pipeline: Object.freeze({
    create: 'pipeline.create',
    list: 'pipeline.list',
    getByName: 'pipeline.getByName',
    runByName: 'pipeline.runByName',
    delete: 'pipeline.delete',
    copy: 'pipeline.copy',
    share: 'pipeline.share',
    listShares: 'pipeline.listShares',
    revokeShare: 'pipeline.revokeShare',
  }),

  node: Object.freeze({
    appendInputSelect: 'node.append.inputSelect',
    appendNormalizer: 'node.append.normalizer',
    editNormalizer: 'node.edit.normalizer',
    appendScaler: 'node.append.scaler',
    editScaler: 'node.edit.scaler',
    appendCapper: 'node.append.capper',
    editCapper: 'node.edit.capper',
    appendAdder: 'node.append.adder',
    editAdder: 'node.edit.adder',
    appendMatcher: 'node.append.matcher',
    editMatcher: 'node.edit.matcher',
    appendLossSubtractor: 'node.append.lossSubtractor',
    editLossSubtractor: 'node.edit.lossSubtractor',
    appendMerger: 'node.append.merger',
    appendBanking: 'node.append.banking',
    appendSettle: 'node.append.settle',
    updateBankingType: 'node.update.bankingType',
    appendBattery: 'node.append.battery',
    editBattery: 'node.edit.battery',
    appendExtrapolation: 'node.append.extrapolation',
    editExtrapolation: 'node.edit.extrapolation',
    appendFinance: 'node.append.finance',
    editFinance: 'node.edit.finance',
    appendConsumptionInput: 'node.append.consumptionInput',
    appendWindGeneration: 'node.append.windGeneration',
    appendSolarGeneration: 'node.append.solarGeneration',
    editWindGeneration: 'node.edit.windGeneration',
    editSolarGeneration: 'node.edit.solarGeneration',
    appendLoan: 'node.append.loan',
    editLoan: 'node.edit.loan',
    appendDepreciation: 'node.append.depreciation',
    editDepreciation: 'node.edit.depreciation',
    appendOperationalCosts: 'node.append.operationalCosts',
    editOperationalCosts: 'node.edit.operationalCosts',
    deleteFromPipeline: 'node.deleteFromPipeline',
    reconfigure: 'node.reconfigure',
    updatePosition: 'node.position.update',
    getPositions: 'node.position.get',
    getDataAtNode: 'node.data.getAtNode',
    getVisualizationData: 'node.data.getVisualization',
    downloadNodeOutput: 'node.download.outputCsv',
  }),

  params: Object.freeze({
    getGlobal: 'params.getGlobal',
    setGlobal: 'params.setGlobal',
    getBillingAnalytics: 'params.getBillingAnalytics',
    setBillingAnalytics: 'params.setBillingAnalytics',
  }),

  analysis: Object.freeze({
    lapsedSum: 'analysis.lapsedSum',
    step3Monthly: 'analysis.step3Monthly',
    bankingSummary: 'analysis.bankingSummary',
    sourceSettlementSummary: 'analysis.sourceSettlementSummary',
    projectAssumptions: 'analysis.projectAssumptions',
    downloadWorkbook: 'analysis.downloadWorkbook',
    exportSummaryPdf: 'analysis.exportSummaryPdf',
  }),

  scenario: Object.freeze({
    metrics: 'scenario.metrics',
    create: 'scenario.create',
    status: 'scenario.status',
    results: 'scenario.results',
    cancel: 'scenario.cancel',
    resume: 'scenario.resume',
    apply: 'scenario.apply',
  }),

  multiUnitOptimization: Object.freeze({
    solve: 'multiUnitOptimization.solve',
  }),

  genUpload: Object.freeze({
    uploadDataFile: 'genUpload.uploadDataFile',
    editGenUploadMetadata: 'genUpload.editGenUploadMetadata',
    listMakesAndModelsByType: 'genUpload.listMakesAndModelsByType',
    listLocationsByType: 'genUpload.listLocationsByType',
    listSubLocationsByTypeAndLocation: 'genUpload.listSubLocationsByTypeAndLocation',
    listMakesAndModelsByTypeAndLocation: 'genUpload.listMakesAndModelsByTypeAndLocation',
    listLocationsByTypeAndMake: 'genUpload.listLocationsByTypeAndMake',
    listPoesByTypeLocationSubLocationAndMake: 'genUpload.listPoesByTypeLocationSubLocationAndMake',
    listIntervalsByTypeMakeAndLocation: 'genUpload.listIntervalsByTypeMakeAndLocation',
    getDocumentById: 'genUpload.getDocumentById',
  }),
});
